import React, { useEffect, useState } from 'react';

import S from './DateRangeInput.module.scss';

const DateRangeInput = ({ argument, onChange }) => {
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('00:00');
  const [endDate, setEndDate] = useState('');
  const [endTime, setEndTime] = useState('23:59');

  // Initialiser les valeurs depuis l'argument
  useEffect(() => {
    if (argument.valeurParDefaut || argument.value) {
      const value = argument.valeurParDefaut || argument.value;

      try {
        // Format attendu: JSON object { start: "YYYY-MM-DD HH:mm", end: "YYYY-MM-DD HH:mm" }
        // ou { startDate, startTime, endDate, endTime }
        let parsed;
        if (typeof value === 'string') {
          parsed = JSON.parse(value);
        } else {
          parsed = value;
        }

        if (parsed.start) {
          const [date, time] = parsed.start.split(' ');
          setStartDate(date || '');
          setStartTime(time || '00:00');
        } else if (parsed.startDate) {
          setStartDate(parsed.startDate || '');
          setStartTime(parsed.startTime || '00:00');
        }

        if (parsed.end) {
          const [date, time] = parsed.end.split(' ');
          setEndDate(date || '');
          setEndTime(time || '23:59');
        } else if (parsed.endDate) {
          setEndDate(parsed.endDate || '');
          setEndTime(parsed.endTime || '23:59');
        }
      } catch (error) {
        console.error('Error parsing date range:', error);
      }
    }
  }, [argument.valeurParDefaut, argument.value]);

  // Mettre à jour la valeur lors du changement
  const handleChange = (field, value) => {
    let newStartDate = startDate;
    let newStartTime = startTime;
    let newEndDate = endDate;
    let newEndTime = endTime;

    switch (field) {
      case 'startDate':
        newStartDate = value;
        setStartDate(value);
        break;
      case 'startTime':
        newStartTime = value;
        setStartTime(value);
        break;
      case 'endDate':
        newEndDate = value;
        setEndDate(value);
        break;
      case 'endTime':
        newEndTime = value;
        setEndTime(value);
        break;
    }

    // Formater la valeur pour l'API
    const formattedValue = JSON.stringify({
      start: `${newStartDate} ${newStartTime}`,
      end: `${newEndDate} ${newEndTime}`,
      startDate: newStartDate,
      startTime: newStartTime,
      endDate: newEndDate,
      endTime: newEndTime,
    });

    onChange('valeurParDefaut', formattedValue);
  };

  return (
    <div className={S.dateRangeContainer}>
      <div className={S.dateRangeContent}>
        {/* Date et heure de début */}
        <div className={S.dateGroup}>
          <div className={S.dateHeader}>
            <span className={S.dateLabel}>Date et heure de début</span>
          </div>
          <div className={S.dateInputs}>
            <div className={S.inputGroup}>
              <label className={S.label}>Date de début</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => handleChange('startDate', e.target.value)}
                className={S.dateInput}
                required={argument.obligatoire}
              />
            </div>
            <div className={S.inputGroup}>
              <label className={S.label}>Heure de début</label>
              <input
                type="time"
                value={startTime}
                onChange={(e) => handleChange('startTime', e.target.value)}
                className={S.timeInput}
                required={argument.obligatoire}
              />
            </div>
          </div>
        </div>

        {/* Date et heure de fin */}
        <div className={S.dateGroup}>
          <div className={S.dateHeader}>
            <span className={S.dateLabel}>Date et heure de fin</span>
          </div>
          <div className={S.dateInputs}>
            <div className={S.inputGroup}>
              <label className={S.label}>Date de fin</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => handleChange('endDate', e.target.value)}
                className={S.dateInput}
                required={argument.obligatoire}
              />
            </div>
            <div className={S.inputGroup}>
              <label className={S.label}>Heure de fin</label>
              <input
                type="time"
                value={endTime}
                onChange={(e) => handleChange('endTime', e.target.value)}
                className={S.timeInput}
                required={argument.obligatoire}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRangeInput;
